module.exports = __webpack_public_path__ + "static/img/kv_message.5540458.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/kv_message.png
// module id = pdXc
// module chunks = 0